<template>
	<div class="advantages">
        <div class="advantages__heading _mb-32-24">
            <h2 class="h2" v-if="title" v-html="title"></h2>
            <p class="p1" :class="{ '_mt-8' : title }" v-if="subtitle" v-html="subtitle"></p>
        </div>
        <div v-if="!isMobile" class="advantages__list">
            <div v-for="(itm, ind) in content" :key="ind" class="advantages__item" :class="`advantages__item-width_${calcLength()}`">
                <div :class="`ico-glass-${itm.icon}`" class="ico-glass ico-glass_size_72 _mb-16"></div>
                <div class="h3" v-html="itm.title"></div>
                <div class="p1 _mt-8">
                    <span v-if="itm.text" v-html="itm.text"></span><hint v-if="hints[ind]" :text="hints[ind]" />
                </div>
                <div class="p1 _mt-16" v-if="itm.button && !itm.modal" v-html="itm.button"></div>
                <div class="p1 _mt-16" v-if="itm.button && itm.modal" v-html="itm.button" @click.prevent="$modal.show(itm.modal)"></div>
            </div>
        </div>
        <div
            v-if="isMobile"
            :class="`swiper-container-${index}`"
            class="swiper-container"
        >
            <div class="swiper-wrapper">
                <div v-for="(itm, ind) in content" :key="ind" class="swiper-slide">
                    <div :class="`ico-glass-${itm.icon}`" class="ico-glass ico-glass_size_72 _mb-16"></div>
                    <div class="h3" v-html="itm.title"></div>
                    <div class="p1 _mt-8">
                        <span v-if="itm.text" v-html="itm.text"></span><hint v-if="hints[ind]" :text="hints[ind]" />
                    </div>
                    <div class="p1 _mt-16" v-if="itm.button && !itm.modal" v-html="itm.button"></div>
                    <div class="p1 _mt-16" v-if="itm.button && itm.modal" v-html="itm.button" @click.prevent="$modal.show(itm.modal)"></div>
                </div>
            </div>
            <div
                :class="`swiper-pagination-${index}`"
                class="swiper-pagination"
            ></div>
        </div>
	</div>
</template>

<script>
import { isMobile } from '../../assets/js/utils'
import Swiper from "swiper";
import Hint from '../../components/Hint.vue';

export default {
	name: 'Advantages',
    components: {
        Hint,
    },
	props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
		content: {
			type: Array,
			default: () => {
				return []
			}
		},
        hints: {
            type: Array,
            default: () => {
                return []
            }
        },
        index: {
            type: String,
            default: '0',
        }
	},
    data() {
        return {
            isMobile: false,
        }
    },
    methods: {
        checkSize() {
            if (this.isMobile !== isMobile()) {
                this.isMobile = isMobile();
            }
        },
        calcLength() {
            const items = this.content.length;
            if (items <= 3) return '3';
            if (items > 3 && items % 4 === 0) return '4';
            return '3';
        },
        initStepsSlider() {
            const config = {
                slidesPerView: 'auto',
                initialSlide: 0,
                centeredSlides: true,
                autoHeight: false,
                pagination: {
                    el: this.$el.querySelector('.swiper-pagination-' + this.index),
                    clickable: true,
                }
            }
            let stepsSlider = new Swiper('.swiper-container-' + this.index, config);
            window.addEventListener('orientationchange', () => {
                if (stepsSlider && stepsSlider instanceof Swiper) {
                    stepsSlider.destroy(true, true);

                    setTimeout(() => {
                        stepsSlider = new Swiper('.swiper-container-' + this.index, config);
                    }, 100);
                }
            });
        },
    },
    created() {
        this.isMobile = isMobile();
        window.addEventListener('resize', this.checkSize, false);
    },
    mounted() {
        this.initStepsSlider();
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.advantages';

#{$b} {
    position: relative;

    &__list {
        display: flex;
        flex-wrap: wrap;
    }

    &__item {

        &-width {

            &_3 {
                @include fluid('width', 384px, auto);

                &:not(:nth-child(3n + 3)) {
                    @include fluid('margin-right', 32px, 0);
                }

                &:nth-child(n + 4) {
                    @include fluid('margin-top', 48px, 0);
                }
            }

            &_4 {
                @include fluid('width', 280px, auto);

                &:not(:nth-child(4n + 4)) {
                    @include fluid('margin-right', 32px, 0);
                }

                &:nth-child(n + 5) {
                    @include fluid('margin-top', 48px, 0);
                }
            }
        }
    }
}
</style>

<style lang="scss">
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

@import '../../assets/scss/ui/ico-glass.scss';

$b: '.advantages';

#{$b} {

    .swiper-pagination {
        @include fluid('bottom', 0);

        .swiper-pagination-bullet-active {
            background: $grey-1514!important;
        }
    }

    .swiper-container {
        @include fluid('padding-bottom', 0, 24px);
    }
}
</style>
